/* import __COLOCATED_TEMPLATE__ from './frequency-input.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { numberToUserDisplay, userEntryToNumber } from '@ebiz/pretty-num';
import type Intl from 'ember-intl/services/intl';

interface FrequencyInputArgs {
  model: number;
  displayFormat?: string;
  significantDigits?: number;
  isInvalidFlag?: boolean;
  disabled?: boolean;
  onInputChanged: (value: number) => void;
}

interface FrequencyInputSignature {
  Args: FrequencyInputArgs;
  Element: HTMLInputElement;
}

export default class FrequencyInput extends Component<FrequencyInputSignature> {
  @service declare intl: Intl;

  get displayFormat() {
    return this.args.displayFormat || 'Engineering';
  }
  get significantDigits() {
    return this.args.significantDigits || 5;
  }
  get value() {
    return numberToUserDisplay(this.args.model, this.displayFormat, this.significantDigits, {
      showZeroes: false,
    });
  }
  @action onValueChanged(event: Event) {
    if (event.target && event.target instanceof HTMLInputElement) {
      if (this.value !== event.target.value) {
        const isValidInput =
          /^(\d*\.)?\d*[EafpnuµmkMGT]?$/.test(event.target.value) && !isNaN(userEntryToNumber(event.target.value, NaN));
        if (isValidInput) {
          const oldValue = this.args.model;
          const newValue = userEntryToNumber(event.target.value);
          this.args.onInputChanged(
            userEntryToNumber(
              numberToUserDisplay(newValue, this.displayFormat, this.significantDigits, { showZeroes: false }),
            ),
          );
          if (oldValue === newValue) {
            // If the user enters the same value but different format, we have to update the display value as well
            // ex. Textbox contains 3.5k and user enters 3500
            event.target.value = this.value;
          }
        } else {
          event.target.value = this.value;
        }
      }
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    FrequencyInput: typeof FrequencyInput;
  }
}
